import { render, staticRenderFns } from "./AiChatboxLinkComponent.vue?vue&type=template&id=92cacec8"
import script from "./AiChatboxLinkComponent.vue?vue&type=script&lang=js"
export * from "./AiChatboxLinkComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports